export default {
  // 页面标题
  campaigns: {
    title: '短信群发'
  },
  automation: {
    title: '短信自动化',
    ndc: '注册未存款',
    inactive: '沉默用户',
    churn: '流失用户',
    welcome: '欢迎短信',
    restorage: '存款用户',
    birthday: '生日提醒',
    vip: 'VIP用户',
    allMembers: '全体会员'
  },
  vip: {
    title: 'SMS VIP用户'
  },

  // 任务类型
  type: {
    bulk: '群发',
    ndc: '注册未存款',
    inactive: '沉默用户',
    churn: '流失用户',
    vip: 'VIP任务',
    welcome: '欢迎短信',
    restorage: '存款用户',
    birthday: '生日提醒',
    unknown: '未知'
  },

  // 表单相关
  form: {
    taskName: '任务名称',
    taskNamePlaceholder: '请输入任务名称',
    country: '地区',
    countryPlaceholder: '请选择地区',
    vip: 'VIP等级',
    vipPlaceholder: '请选择VIP等级',
    status: '状态',
    statusPlaceholder: '请选择状态',
    template: '短信模板',
    templatePlaceholder: '请选择短信模板',
    selectCategoryFirst: '请先选择模板分类',
    agent: '代理',
    agentPlaceholder: '请输入代理名称',
    haveLogin: '有登录',
    haveBet: '有投注',
    inOut: '用户类型',
    inOutPlaceholder: '请选择用户类型',
    sendTime: '发送时机',
    sendTimePlaceholder: '请输入数值',
    depositOrder: '存款次序',
    depositOrderPlaceholder: '请输入具体次数，如5',
    dailyPlaceholder: '请输入天数',
    weeklyPlaceholder: '请输入1-7（1=周一，7=周日）',
    monthlyPlaceholder: '请输入1-31（每月几号）',
    timeUnit: '时间单位',
    templateContentPlaceholder: '请先选择模板',
    templateContent: '模板内容（只读）',
    importUsers: '导入用户名',
    importPhones: '导入手机号',
    bulkSend: '群发',
    selectFile: '选择档案（CSV；逗号/空格/换行；自动去重）',
    chooseFile: '选择档案',
    uploaded: '已上传',
    notImported: '未导入',
    importUsersPlaceholder: '导入用户名（CSV；逗号/空格/换行；自动去重）',
    importPhonesPlaceholder: '导入手机号（CSV；逗号/空格/换行；自动去重）'
  },

  // 上传相关
  upload: {
    invalidFileType: '请上传Excel相关文件（.xlsx, .xls, .xlsm, .xlsb, .csv, .txt）',
    success: 'Excel文件上传成功',
    failed: 'Excel文件上传失败',
    error: 'Excel文件上传失败: {{error}}',
    pleaseUploadFirst: '请先上传Excel文件'
  },

  // 用户类型
  inOut: {
    internal: '内部用户',
    external: '外部用户'
  },

  // 时间单位
  timeUnit: {
    minutes: '分钟',
    hours: '小时',
    days: '天',
    weeks: '周',
    months: '月'
  },

  // 表格相关
  table: {
    taskName: '任务名称',
    template: '模板',
    country: '国家',
    vipLevel: 'VIP等级',
    sendTiming: '发送时机',
    status: '状态',
    actions: '操作',
    createUser: '创建人',
    createTime: '创建时间',
    operator: '操作人',
    depositOrder: '存款次序',
    depositOrderValue: '第{{times}}次'
  },

  // 条件标签
  condition: {
    haveLogin: '有登录',
    haveBet: '有投注'
  },

  // 状态相关
  status: {
    enabled: '启用',
    disabled: '禁用'
  },

  // 按钮相关
  button: {
    create: '新建任务',
    execute: '立即执行',
    sendNow: '立即发送',
    uploadFile: '上传文件',
    createInternalCampaign: '新增站内用户群发',
    createExternalCampaign: '新增站外用户群发',
    importLog: '导入名单日志'
  },

  // 弹窗相关
  modal: {
    createTitle: '新建SMS任务',
    editTitle: '编辑SMS任务',
    viewTitle: '查看SMS任务',
    importLogTitle: '导入名单日志',
    close: '关闭'
  },

  // 存款用户任务提示
  restorage: {
    hint: '指符合条件的用户：在第N次存款后23小时内未再次存款，将收到该短信。'
  },

  // 高级筛选
  advancedFilter: {
    title: '高级筛选',
    excludeUser: '排除官网用户',
    excludeAgent: '排除代理用户',
    excludeAgentWithHint: '排除代理用户（可搜索，可多选）',
    selectAgents: '选择要排除的代理',
    selectAgentsPlaceholder: '请选择代理（可搜索、多选）',
    off: '关闭',
    on: '开启',
    excludeAllAgents: '排除全部代理',
    excludeSomeAgents: '排除个别代理',
    mobileValid: '手机号已认证用户',
    // VIP任务专用
    recentLoginPrefix: '仅向最近',
    recentLoginSuffix: '天内登录的用户发送',
    recentLoginFullText: '仅向最近[]天内登录的用户发送',
    recentLoginTooltip: '系统将在发送前筛选最近n天有登录记录的用户（留空表示不限）',
    recentLoginDays: '最近{{days}}日内登录用户'
  },

  // 验证相关
  validation: {
    taskNameRequired: '请输入任务名称',
    countryRequired: '请选择国家',
    templateRequired: '请选择短信模板',
    sendTimeRequired: '请输入发送时间',
    timeUnitRequired: '请选择时间单位',
    weeklyRangeError: '周发送次数必须在1-7之间（1=周一，7=周日）',
    monthlyRangeError: '月发送日期必须在1-31之间',
    agentRequired: '请选择要排除的代理',
    recentDayRequired: '请输入天数',
    recentDayRange: '天数范围必须在1-365之间',
    excludeUserAndAllAgentsConflict: '排除官网用户和排除全部代理不能同时选中',
    excludeUserAndAllAgentsConflictSubmit: '排除官网用户和排除全部代理不能同时选中，请修改后再提交',
    depositOrderRequired: '请输入存款次序',
    depositOrderMin: '存款次序需不少于1次',
    sendTimeMinutesMax: '分钟数不能超过4320',
    sendTimeHoursMax: '小时数不能超过72小时',
    sendTimeDaysMax: '天数不能超过30天'
  },

  // 消息相关
  message: {
    queryFailed: '查询失败',
    createSuccess: '创建成功',
    createFailed: '创建失败',
    updateSuccess: '更新成功',
    updateFailed: '更新失败',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    statusUpdateSuccess: '状态更新成功',
    statusUpdateFailed: '状态更新失败',
    executeSuccess: '执行成功',
    executeFailed: '执行失败'
  },

  // 确认相关
  confirm: {
    delete: '确定要删除此任务吗？',
    toggleStatus: '确定要切换此任务的状态吗？',
    execute: '确定要立即执行此任务吗？',
    send: '确定要立即发送此任务吗？'
  },

  // 分页相关
  pagination: {
    total: '共 {{total}} 条记录'
  },

  // 存款用户任务提示
  automationRestorageNote: '存款用户任务将在用户完成首存后的指定时间触发，请确保模板内容符合二次激活场景。',

  // 导入名单日志相关
  importLog: {
    taskName: '任务名称',
    taskCode: '任务编号',
    uploadFileStatus: {
      '80009001': '待處理',
      '80009002': '已完成'
    },
    header: {
      taskName: '任务',
      importer: '导入者',
      operator: '操作人',
      latestImportTime: '最近导入时间',
      importFileName: '导入文件名称',
      importCompleteTime: '导入完成时间',
      importStatus: '导入状态'
    },
    stats: {
      success: '成功导入',
      failed: '导入失败',
      total: '导入总数'
    },
    failureDetails: {
      title: '失败明细',
      searchPlaceholder: '搜索失败用户名',
      exportFailed: '导出失败',
      memberAccount: '会员账号',
      failureReason: '失败原因',
      failureTime: '失败时间',
      rowNumber: '行号',
      remarks: '备注',
      hint: '提示:仅保留一个月内失败用户账号',
      loading: '載入中...',
      noFailedRecords: '沒有失敗記錄',
      noImportRecords: '暫無導入記錄',
      exportNotImplemented: '導出功能待實現'
    }
  }
};
